// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131735/js/" + chunkId + "." + {"44":"2ef26b86","225":"0fbe0095","481":"ecc7e8c4","486":"d5aa7d7c","770":"3a412fda"}[chunkId] + ".0.09193491743570892.chunk.js";
};